import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import { ThemeProvider } from 'styled-components';

import App from './routes/App';

import './i18n';

import './fonts.css';
import './index.css';
import sentryService from './providers/sentry';
import theme from './theme';
import { GoogleOAuthProvider } from '@react-oauth/google';

sentryService.init();

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

if (import.meta.env.PROD) {
  LicenseInfo.setLicenseKey(
    '95f97d661ff9c866a07f84ec43d305c9Tz04Njc1MSxFPTE3NDI0NTk1NzQwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
  );
} else {
  LicenseInfo.setLicenseKey('UNLICENSED');
}

root.render(
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </GoogleOAuthProvider>
);
